import React from "react";
import PropTypes from "prop-types";

import { DynamicField } from "scenes/Hubly/components/Workspace/components/FormModal/components";

import { useWorkflowConditionController } from "../../hooks";
import { Dropdown } from "..";

export function WorkflowCondition({
  disabled,
  id,
  operand,
  parameters,
  datePart,
  workflowPart,
  value,
}) {
  const {
    workflowPartProps,
    datePartProps,
    operandProps,
    fieldProps,
    hasDatePart,
    hasOperand,
    hasField,
  } = useWorkflowConditionController({
    name: id,
    parameters: parameters,
    operand: operand,
    value: value,
    workflowPart: workflowPart,
    datePart: datePart,
  });

  return (
    <div data-test="workflow-condition" style={{ display: "flex" }}>
      <div style={{ width: 200 }}>
        <Dropdown
          disableClearable
          includeInputInList
          data-test="workflow-workflowpart-dropdown"
          disabled={disabled}
          {...workflowPartProps}
        />
      </div>
      {hasDatePart && (
        <div style={{ width: 120, margin: "0px 16px" }}>
          <Dropdown
            disableClearable
            includeInputInList
            data-test="workflow-datepart-dropdown"
            disabled={disabled}
            {...datePartProps}
          />
        </div>
      )}
      {hasOperand && (
        <div
          style={
            hasDatePart
              ? { width: 135, marginRight: "16px" }
              : { width: 135, margin: "0px 16px" }
          }
        >
          <Dropdown
            disableClearable
            includeInputInList
            data-test="workflow-operand-dropdown"
            disabled={disabled}
            {...operandProps}
          />
        </div>
      )}
      {hasField && (
        <div style={{ width: 200 }}>
          <DynamicField field={{ ...fieldProps, disabled: disabled }} />
        </div>
      )}
    </div>
  );
}

WorkflowCondition.propTypes = {
  id: PropTypes.string.isRequired,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      dateParts: PropTypes.array,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  operand: PropTypes.string,
  datePart: PropTypes.string,
  workflowPart: PropTypes.string,
};

WorkflowCondition.defaultProps = {
  value: null,
  disabled: false,
  operand: "",
  datePart: null,
  workflowPart: "",
};

export default WorkflowCondition;
